import HeaderComponent from "@/components/header/Header/HeaderComponent";
import React, {useEffect, useState} from "react";
import LoginComponent from "@/components/login/login.component";

export default function Home() {

    const login = (data: boolean) => {
    }

    return (<div>
        {/*<HeaderComponent menu={[]}></HeaderComponent>*/}
        <LoginComponent onLogin={login}></LoginComponent>
    </div>);
}
